import type { ReactNode } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import theme from './theme';

/**
 * Single place the MUI theme is applied. Kept as its own component (rather than
 * inlined in App) so tests can wrap components in the same provider — see
 * tests/renderWithTheme.
 */
const AppThemeProvider = ({ children }: { children: ReactNode }) => (
  <MuiThemeProvider theme={theme}>
    <CssBaseline />
    {children}
  </MuiThemeProvider>
);

export default AppThemeProvider;
